import React from 'react';
import moment from 'moment';

const IPFSSummary = ({ hash }) => {
    return (
        <div className='card signed-summary'>
            <div className="card-content grey-text text-darken-3">
                <span className="card-title">{hash.title}</span>
                <p>Signed by {hash.author1FirstName} {hash.author1LastName} & {hash.author2FirstName} {hash.author2LastName} </p>
                <p>{moment(hash.time.toDate()).calendar()}</p>

            </div>
        </div>
    )
};

export default IPFSSummary;